import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Pagination } from '@/common/types';
import { API_URL } from '@/dtos';

import {
  IUnappliedFundsByOrganizationDto,
  UnappliedFundsOrganization,
  UnappliedFundsOrganizationsParams,
} from '../UnappliedFundsOrganizations.types';

const QUERY_KEY = 'GET_UNAPPLIED_FUNDS_ORGANIZATIONS';

const fetchUnappliedFundsOrganizations = ({ searchValue, page, size }: UnappliedFundsOrganizationsParams) =>
  api.get<Pagination<IUnappliedFundsByOrganizationDto>>(API_URL.UNMATCHED_PUSH_TRANSACTIONS_BY_ORGANIZATION, {
    params: { search: searchValue || undefined, page, size },
  });

const mapDtoToOrganization = (dto: IUnappliedFundsByOrganizationDto): UnappliedFundsOrganization => ({
  orgId: dto.org_id ?? 0,
  name: dto.organization_name || '',
  subsidiaryName: dto.subsidiary_name || undefined,
  unappliedFunds: dto.unapplied_funds ?? 0,
  unpaidInvoicesAmount: dto.unpaid_invoices_amount ?? 0,
  unpaidInvoicesCount: dto.unpaid_invoices_count ?? 0,
});

const useGetUnappliedFundsOrganizationsQuery = ({
  searchValue,
  page,
  size,
}: UnappliedFundsOrganizationsParams) => {
  const { data, isLoading } = useQuery([QUERY_KEY, searchValue, page, size], () =>
    fetchUnappliedFundsOrganizations({ searchValue, page, size })
  );

  const organizations = useMemo(
    () => (data?.data?.content || []).map(mapDtoToOrganization),
    [data?.data?.content]
  );

  return {
    organizations,
    total: data?.data?.totalElements ?? 0,
    isLoading,
  };
};

export default useGetUnappliedFundsOrganizationsQuery;
